// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"34450b96","76":"1ab1b93f","142":"29caf805","295":"be5ad990","335":"a65d66e1","358":"4e0ebe1d","368":"1eecb39f","376":"905c3ba6","438":"c28d7ddf","700":"bb999528","729":"f11446e2","815":"c633972d","870":"2920c22f"}[chunkId] + ".chunk.js";
};